var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ph-item m-d-16 p-0"},[_c('div',{staticClass:"ph-col-12 p-y-12 p-x-20 border-bottom"},[_c('div',{staticClass:"ph-row m-0"},[_c('div',{staticClass:"ph-col-4 big m-d-6"})]),_c('div',{staticClass:"ph-row m-0"},[_c('div',{staticClass:"ph-col-8 m-d-8"}),_c('div',{staticClass:"ph-col-8 m-d-8"})])])])
}]

export { render, staticRenderFns }